import React, { useEffect, useState } from 'react';
import * as ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router';
import moment from 'moment/moment';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { szltStatusFormatter } from '../../../utils/formatters';
import { getRegisterData } from '../reducer';
import SmevChecker from '../../Application/components/SmevChecker';
import {
  annulmentSZLT, inactiveSZLT, loadSmevCheckSZLTList, resumedSZLT, smevCheckAllSZLT,
} from '../actions';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { getResponseError, responseLogWithNotification } from '../../../utils/utils';
import SZLTViewData from './SZLTViewData';
import CarrierMiniGrid from './CarrierMiniGrid';
import VehiclesMiniGrid from './VehiclesMiniGrid';
import AnnulmentReasonDialog from './AnnulmentReasonDialog';
import DocumentList from '../../Application/components/DocumentList';
import { RegistryRelationHistoryDialog } from './RegistryRelationHistoryDialog';
import RegistryPageModal from './RegistryPageModal';
import ApplicationLegend from '../../Application/components/ApplicationLegend';
import {
  APPLICATION_STATUS, REGION_REGISTRY_RELATION, REGISTRIES_TYPE, REGISTRY_STATUS,
} from '../../../configs';
import InactiveReasonDialog from './InactiveReasonDialog';
import RestoreReasonDialog from './ResumedReasonDialog';
import AccordionWithPreview from '../../../components/base/Accordion/AccordionWithPreview';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import { loadAwaitDocument } from '../../Application/actions';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';

export default function SZLTView(props) {
  const dispatch = useDispatch();
  const {
    onClose = () => {},
    handleEdit = () => {},
    loadData = () => {},
    handleExtract = () => {},
    formMeta,
  } = props;
  const [isHistoryPopUp, setIsHistoryPopUp] = useState(false);
  const [isSameRegistryPopUp, setIsSameRegistryPopUp] = useState(false);
  const [showInactive, setShowInactive] = useState(false);
  const [showAnnulment, setShowAnnulment] = useState(false);
  const [showResumed, setShowResumed] = useState(false);
  const {
    currentSZLT = {},
    smevCheckSZLTList = [],
    loadingCheckAllSzlt,
  } = useSelector(getRegisterData);

  const loadDocument = () => {
    dispatch(loadAwaitDocument({ filter: { source_subject_id: currentSZLT?.id } })).catch(responseLogWithNotification);
  };

  const handleAnnulment = values => {
    setShowAnnulment(false);
    dispatch(annulmentSZLT({ id: currentSZLT.id, values }))
      .then(() => {
        successNotification('Аннулирование реестровой записи', 'Сформировано Решение об аннулировании');
        loadData();
        loadDocument();
      })
      .catch(response => errorNotification('Аннулирование карточки СЗЛТ', getResponseError(response)));
  };

  const handleInactive = values => {
    setShowInactive(false);
    dispatch(inactiveSZLT({ id: currentSZLT.id, values }))
      .then(() => {
        successNotification('Приостановка', 'Сформировано Решение о приостановке');
        loadData();
        loadDocument();
      })
      .catch(response => errorNotification('Приостановка карточки СЗЛТ', getResponseError(response)));
  };

  const handleResumed = values => {
    setShowResumed(false);
    dispatch(resumedSZLT({ id: currentSZLT.id, values }))
      .then(() => {
        successNotification('Возобновление реестровой записи', 'Сформировано Решение о возобновлении');
        loadData();
        loadDocument();
      })
      .catch(response => errorNotification('Возобновление карточки СЗЛТ', getResponseError(response)));
  };

  useEffect(() => {
    dispatch(loadSmevCheckSZLTList(currentSZLT.id)).catch(responseLogWithNotification);
  }, []);

  const {
    vehicles = [],
    carriers = [],
    documents = [],
    legal_entity_type = 0,
  } = currentSZLT;

  return ReactDOM.createPortal(
    <div className="application-form">
      <TimerLoader loading={loadingCheckAllSzlt} />
      <div className="application-form-header">
        <div className="breadcrumbs">
          <span className="breadcrumbs-prev">Реестры</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          <span className="breadcrumbs-prev">Реестр СЗЛТ</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          <span className="breadcrumbs-prev">Карточка реестра СЗЛТ</span>
          <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
          <span
            className="breadcrumbs-current"
          >Карточка реестра СЗЛТ № {currentSZLT?.number || 'Без номера'} (просмотр)
          </span>
        </div>
        <div className="legend-button">
          <Icons width={24} height={24} customIcon icon="helper" className="legend-icon" />
          <ApplicationLegend />
        </div>
        <div className="close-button" onClick={onClose}>
          <Icons width={24} height={24} customIcon icon="close" />
        </div>
      </div>
      <div className="application-form-body application-form-view szlt-registry">
        <div className="application-form-body-wrapper">
          <div className="application-form-column">
            <div className="application-form-content">
              <div className="application-form-fields">
                <div className="application-form-fields-wrapper custom-scroll-theme">
                  <div className="afc-header">
                    Запись СЗЛТ №{currentSZLT.number}
                    {szltStatusFormatter(currentSZLT.status)}
                    <div className="afc-header-link">
                      <div className="application-options ms-lg-auto">
                        <TooltipWithPortal
                          content={<Icons customIcon icon="more-vert" className="more-vert" />}
                          classNamePortal="more-actions application-options-dropdown"
                          tooltipContent={(
                            <div className="more-wrapper">
                              <Button
                                variant="link"
                                className="w-100 more-button"
                                onClick={() => handleExtract(currentSZLT)()}
                              >
                                Сформировать выписку
                              </Button>
                              <Button
                                variant="link"
                                className="w-100 more-button"
                                onClick={() => setIsSameRegistryPopUp(true)}
                              >
                                Реестровые записи в отношении данного СЗЛТ
                              </Button>
                              <Button
                                variant="link"
                                className="w-100 more-button"
                                onClick={() => window.open(`/application?subject_id=${currentSZLT.id}&filter=carrier&status=${Object.values(APPLICATION_STATUS)}&number=${currentSZLT.number}&created_at=${[moment(currentSZLT.created_at).subtract(1, 'year').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]}`, '_blank')}
                              >
                                Обращения
                              </Button>
                              <Button
                                variant="link"
                                className="w-100 more-button"
                                onClick={() => window.open(`/region-registry/history?subject_id=${currentSZLT.id}&subject_type=order_service`, '_blank')}
                              >
                                История изменений
                              </Button>
                            </div>
                            )}
                          classNameWrapper="more-tooltip-wrapper"
                          className="more-tooltip"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="afc-body">
                    <div className="afc-main">
                      <SZLTViewData currentSZLT={currentSZLT} formMeta={formMeta} />
                      <div className="hr-row" />
                      <AccordionWithPreview
                        title="Документы"
                        content={(
                          <DocumentList
                            id={currentSZLT?.id}
                            loadData={loadData}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {currentSZLT?.status !== REGISTRY_STATUS.ANNULMENT
                ? (
                  <div className="application-form-footer">
                    <Button
                      variant="secondary"
                      onClick={handleEdit}
                    >Изменить
                    </Button>
                    {currentSZLT?.status === REGISTRY_STATUS.INACTIVE ? (
                      <Button
                        className="ms-lg-auto"
                        variant="secondary"
                        onClick={() => setShowResumed(true)}
                      >Возобновить
                      </Button>
                    ) : (
                      <Button
                        className="ms-lg-auto"
                        variant="secondary"
                        onClick={() => setShowInactive(true)}
                      >Приостановить
                      </Button>
                    )}
                    <Button onClick={() => setShowAnnulment(true)}>Аннулировать</Button>
                  </div>
                ) : null}
            </div>
            <div className="application-form-content afc-right">
              <VehiclesMiniGrid
                params={{
                  order_service_id: currentSZLT.id,
                }}
                setIsHistoryPopUp={setIsHistoryPopUp}
                isCarrierRelationType={false}
              />
              <CarrierMiniGrid
                params={{
                  order_service_id: currentSZLT.id,
                }}
                setIsHistoryPopUp={setIsHistoryPopUp}
                isVehicleRelationType={false}
              />
            </div>
          </div>
          <div className="application-form-content smev-checker">
            <SmevChecker
              list={smevCheckSZLTList}
              startCheckAction={smevCheckAllSZLT}
              current={currentSZLT}
              loadData={loadData}
            />
          </div>
          {isHistoryPopUp ? (
            <RegistryRelationHistoryDialog
              currentCarrier={currentSZLT}
              subject_type="order_service"
              subject_id={currentSZLT?.id}
              log_name={isHistoryPopUp === 'vehicle' ? REGION_REGISTRY_RELATION.CARRIER_VEHICLE : REGION_REGISTRY_RELATION.ORDER_SERVICE_CARRIER}
              onClose={() => setIsHistoryPopUp(false)}
            />
          ) : null}
          {isSameRegistryPopUp
            ? (
              <RegistryPageModal
                type="szlt"
                onClose={() => setIsSameRegistryPopUp(false)}
                customFilter={{
                  inn: currentSZLT?.inn,
                }}
                title="Реестровые записи в отношении данного СЗЛТ"
                filterName="szlt-same-list-modal-filter"
              />
            ) : null}
          {showInactive ? (
            <InactiveReasonDialog
              typeRegistry={REGISTRIES_TYPE.ORDER_SERVICE}
              current={currentSZLT}
              legal_entity_type={legal_entity_type}
              close={() => setShowInactive(false)}
              send={handleInactive}
            />
          ) : null}
          {showAnnulment ? (
            <AnnulmentReasonDialog
              typeRegistry={REGISTRIES_TYPE.ORDER_SERVICE}
              current={currentSZLT}
              legal_entity_type={legal_entity_type}
              close={() => setShowAnnulment(false)}
              send={handleAnnulment}
            />
          ) : null}
          {showResumed ? (
            <RestoreReasonDialog
              typeRegistry={REGISTRIES_TYPE.ORDER_SERVICE}
              current={currentSZLT}
              legal_entity_type={legal_entity_type}
              close={() => setShowResumed(false)}
              send={handleResumed}
            />
          ) : null}
        </div>
      </div>
    </div>,
    document.getElementById('app-content'),
  );
}
